import giftUrlApi from "./giftUrlApi";

export const getGiftCollectionByProfile = async (profileId: string) => {
    const userCollections = await giftUrlApi().getCollectionsByUser(profileId)
    const giftCollection = userCollections?.length && userCollections.filter((coll: any) => coll.typeCollection === "my_gifts")
    return giftCollection?.length && giftCollection[0].cardCollectionId
}import giftUrlApi from "./giftUrlApi";

export const getGiftCollectionByProfile = async (profileId: string) => {
    const userCollections = await giftUrlApi().getCollectionsByUser(profileId)
    const giftCollection = userCollections?.length && userCollections.filter((coll: any) => coll.typeCollection === "my_gifts")
    return giftCollection?.length && giftCollection[0].cardCollectionId
}